import { GQLRatingQuery } from 'components/page/RatingWave/gql/__generated__/Rating'

export const CREATE_PHOTOS_QUEUE = 'CREATE_PHOTOS_QUEUE' as const

export const createPhotosQueueAction = (
  photos: GQLRatingQuery['photoRating']['queue']['photos']
) => ({
  type: CREATE_PHOTOS_QUEUE,
  photos,
})

export const CLEAR_PHOTOS_QUEUE = 'CLEAR_PHOTOS_QUEUE' as const

export const clearPhotosQueueAction = () => ({
  type: CLEAR_PHOTOS_QUEUE,
})
